import { MinzeElement, Reactive, EventListeners } from 'minze'
import MainModule from '../../modules/main'
import redaxios from 'redaxios'
import { config } from '../../constants/config'
import { Locale } from '../../modules/locale'
import { EMAIL_REGEX } from '../../modules/utils'
import { Routing } from '../../modules/routing'

Locale.getInstance().registerKeySet('fr', 'forgotPassword', {
  description: 'Entrez votre courriel pour recevoir les instructions de réinitialisation.',
  email: 'Courriel',
  emailPlaceholder: 'Entrez votre adresse courriel',
  send: 'Envoyer un lien de réinitialisation',
  errors: {
    email: 'Veuillez entrer une adresse courriel valide.',
    misc: 'Une erreur est survenue. Veuillez réessayer plus tard.',
    noUserFound: "Aucun utilisateur avec cet email n'a été trouvé",
  },
})

Locale.getInstance().registerKeySet('en', 'forgotPassword', {
  description: 'Enter e-mail to receive instructions on how to reset password.',
  email: 'E-mail',
  emailPlaceholder: 'Enter your email address',
  send: 'Send link to reset password',
  errors: {
    email: 'Please enter a valid email address.',
    misc: 'An error occurred. Please try again later.',
    noUserFound: 'No user with this email has been found',
  },
})

export interface LvcForgotPasswordContent {
  loading: boolean
}

export class LvcForgotPasswordContent extends MinzeElement {
  reactive: Reactive = [['loading', false]]
  errors: any = {
    email: false,
  }
  onReady(): void | Promise<void> {
    const mainModule = MainModule.getInstance()

    const userData = mainModule.getAuth().getUserData()

    if (userData && userData.profile) {
      mainModule.getRouting().goToLastPage()
    }
  }

  async save(): Promise<void> {
    const mainModule = MainModule.getInstance()
    const emailField = this.select('[name="email"]') as HTMLInputElement

    const email = emailField?.value

    for (const key in this.errors) {
      this.errors[key] = false
    }

    if (!email || EMAIL_REGEX.test(email) === false) {
      this.errors.email = Locale.getKey('forgotPassword.errors.email')
    }

    let hasError = false
    for (const key in this.errors) {
      if (this.errors[key]) {
        hasError = true
        break
      }
    }

    if (hasError) {
      this.rerender()
      return
    }
    try {
      this.loading = true
      const response = await redaxios.post(`${config.backendApi}/user/auth/forgot-password`, {
        email,
      })
      this.loading = false
      if (response.status === 200) {
        const language = Locale.language
        mainModule
          .getRouting()
          .goTo(`${Routing.ROUTES[language].login}?recover-password-email-sent=true`)
      } else {
        this.errors.email = Locale.getKey('forgotPassword.errors.misc')
      }
    } catch (err) {
      console.error(err)
      this.errors.email = Locale.getKey('forgotPassword.errors.misc')
      this.loading = false
      this.rerender()
    }
    this.rerender()
  }

  html = () => `
    <div class="form">
      <lvc-box mt="${window.matchMedia('(max-width: 730px)').matches ? '8px' : '24px'}">
        <lvc-text font-preset="small">
          ${Locale.getKey('forgotPassword.description')}
        </lvc-text>
      </lvc-box>
      <lvc-box mt="24px">
        <lvc-input id="email" name="email" placeholder="${Locale.getKey('forgotPassword.emailPlaceholder')}" default-value="" label="${Locale.getKey('forgotPassword.email')}" error="${this.errors.email}">
        </lvc-input>
      </lvc-box>
      <lvc-box 
        display="${window.matchMedia('(max-width: 730px)').matches ? 'block' : 'flex'}" 
        mt="${window.matchMedia('(max-width: 730px)').matches ? '24px' : '32px'}" 
        justifyContent="center"
      >
        <lvc-button enable-hover-box-shadow="true"
          name="save" 
          width="${window.matchMedia('(max-width: 730px)').matches ? '100%' : 'fit-content'}"
        >
          <div class="button-content-wrapper">
            ${this.loading ? `<div class="btn-loader"></div>` : ``}
            <div>
            ${Locale.getKey('forgotPassword.send')}
            <div>
          </div>
        </lvc-button>
      </lvc-box>  
    </div>
  `

  css = () => `
    lvc-button {
      pointer-events: ${this.loading ? 'none' : 'auto'};
    }
    .button-content-wrapper {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: center;
    }
    .btn-loader {
      border: 2px solid #fff;
      border-top: 2px solid transparent;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      animation: spin 1s linear infinite;
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `

  eventListeners: EventListeners = [['[name="save"]', 'click', this.save.bind(this)]]
}
